var formatProductChoice = function(choice) {
  if (choice) {
    const words = choice.split(" ");
    return words[0];
  }
};

export default formatProductChoice;
